import { APIRequest } from '@/app/services/APIRequest';

export default async function GETWarehouse(){
  return APIRequest({
    method: 'GET',
    url: '/warehouse/list',
    auth: true
  }).then(response => {
    // console.log(response);
    if (response.data.code === 10){
      return {
        code: 10,
        message: response.data.message || '',
        result: response.data.result
      };
    }
    return response;
  });
}
